<template lang="pug">
  .floating-button
    f7-fab(
      position="right-bottom"
      slot="fixed"
      @click="$emit('click')")
      f7-icon(
        :ios="`f7:${type}`"
        :md="`material:${type}`"
      )
</template>

<style>
.floating-button .fab > a {
  background-color: #1faab3;
}

.floating-button div.fab.fab-right-bottom {
  right: 24px;
  bottom: 24px;
}
</style>

<script>
export default {
  props: {
    type: { type: String, default: 'add' },
  },
}
</script>
